import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

// Hierarchical Unit Collection (companies/{companyId}/sites/{siteId}/units/{unitId})
export const Unit = z.object({
  siteId: z.string(),
  companyId: z.string(),
  buildingDesignation: z.string(),
  ahjId: z.string().nullable().default(null),
  manufacturer: z.string().nullable().default(null),
  manufacturerSerial: z.string().nullable().default(null),
  unitId: z.string(),
  // Last 8 characters of unitId for legacy QR code lookups
  unitIdSuffix: z.string().nullable().default(null),
  type: z.string(),

  // Survey status
  needsSurvey: z.boolean().default(false),

  // Auto-renewal control
  doNotRenew: z.boolean().default(false),

  // Archiving - hidden from active views, data preserved
  archivedAt: FirestoreTimestamp.nullable().default(null),

  // Denormalized for offline access
  companyName: z.string().optional(),

  // Denormalized from parent site for collection group query permissions
  workRouteIds: z.array(z.string()).default([]),

  status: z.enum(['pending', 'processed', 'error']).default('pending'),

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,
})

export type Unit = z.infer<typeof Unit>
